(function(){
  'use strict';
  var TARGET = 4; // other products alongside the current one (5 cards total)

  function esc(s){ return (s||'').replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function money(v){ return '$' + parseFloat(v || 0).toFixed(2) + ' USD'; }
  function cleanUrl(u){ return (u||'').split('?')[0]; }
  function bigImg(u){
    if(!u) return '';
    var sep = u.indexOf('?') === -1 ? '?' : '&';
    return u + sep + 'width=300';
  }
  // Zero-image products get this plain "Image not available" placeholder
  // instead of a broken/empty <img src="">.
  var placeholderIcon = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="9" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>';

  // Tier 1 (same type) / Tier 2 (same vendor): Shopify predictive search.
  // Note: predictive search returns the product's type on a field literally
  // called "type" (not "product_type") -- using the wrong key silently
  // rendered blank "Type" cells.
  function fromSuggest(field, value, seen, limit){
    if(!value || limit <= 0) return Promise.resolve([]);
    var q = field + ':"' + value + '"';
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=20')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var out = [];
        for(var i = 0; i < products.length && out.length < limit; i++){
          var p = products[i];
          if(seen[String(p.id)]) continue;
          seen[String(p.id)] = true;
          var rawImg = (p.featured_image && p.featured_image.url) || p.image || '';
          out.push({ id: p.id, title: p.title, url: cleanUrl(p.url), image: bigImg(rawImg), type: p.type || '', price: money(p.price), vendor: p.vendor || '' });
        }
        return out;
      })
      .catch(function(){ return []; });
  }

  // Tier 3: the product's own real collection -- its actual store
  // category -- the broadest relevant fallback before giving up.
  function fromCollection(handle, seen, limit){
    if(!handle || limit <= 0) return Promise.resolve([]);
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=20')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data && data.products) || [];
        var out = [];
        for(var i = 0; i < products.length && out.length < limit; i++){
          var p = products[i];
          if(seen[String(p.id)]) continue;
          seen[String(p.id)] = true;
          var v = (p.variants && p.variants[0]) || {};
          var img = (p.images && p.images[0] && p.images[0].src) || '';
          out.push({ id: p.id, title: p.title, url: '/products/' + p.handle, image: bigImg(img), type: p.product_type || '', price: money(v.price), vendor: p.vendor || '' });
        }
        return out;
      })
      .catch(function(){ return []; });
  }

  function buildCards(section, items){
    var wrap = section.querySelector('[data-compare-table]');
    if(!wrap || !items.length) return;
    wrap.innerHTML = items.map(function(p){
      var mediaHtml = p.image
        ? '<img src="'+p.image+'" alt="'+esc(p.title)+'" loading="lazy" width="300" height="300">'
        : '<div class="compare-card__media-placeholder">' + placeholderIcon + '<span>Image not available</span></div>';
      return '<div class="compare-card">' +
        '<div class="compare-card__media">'+mediaHtml+'</div>' +
        '<p class="compare-card__title" title="'+esc(p.title)+'">'+esc(p.title)+'</p>' +
        '<a class="btn btn-secondary btn-sm" href="'+p.url+'">View Detail &rarr;</a>' +
        '<dl class="compare-card__specs">' +
          '<div class="compare-card__row"><dt>Type</dt><dd>'+esc(String(p.type||''))+'</dd></div>' +
          '<div class="compare-card__row"><dt>Price</dt><dd>'+esc(String(p.price||''))+'</dd></div>' +
          '<div class="compare-card__row"><dt>Vendor</dt><dd>'+esc(String(p.vendor||''))+'</dd></div>' +
        '</dl>' +
      '</div>';
    }).join('');
    wrap.hidden = false;
  }

  document.querySelectorAll('[data-compare]').forEach(function(section){
    var vendor = section.getAttribute('data-vendor');
    var type = section.getAttribute('data-type');
    var categoryHandle = section.getAttribute('data-category-handle');
    var excludeId = section.getAttribute('data-exclude');
    // The current-product data now lives inside this same <section> --
    // querying the section directly (rather than document) keeps this
    // safe if the section is ever rendered more than once on a page.
    var currentEl = section.querySelector('[data-current-product]');
    var current = null;
    try { current = JSON.parse(currentEl.textContent); } catch(e){}
    if(current && current.image){ current.image = bigImg(current.image); }

    var seen = {};
    if(excludeId) seen[String(excludeId)] = true;

    // Relevance-first, additive fill: pull from same type first, then top
    // up from same vendor, then top up from the product's own collection
    // (category), stopping once TARGET unique products are found or every
    // tier is exhausted. Only hides the section if nothing relevant turns
    // up anywhere.
    fromSuggest('product_type', type, seen, TARGET)
      .then(function(items){
        if(items.length >= TARGET) return items;
        return fromSuggest('vendor', vendor, seen, TARGET - items.length).then(function(more){ return items.concat(more); });
      })
      .then(function(items){
        if(items.length >= TARGET) return items;
        return fromCollection(categoryHandle, seen, TARGET - items.length).then(function(more){ return items.concat(more); });
      })
      .then(function(items){
        if(!items.length) return;
        var all = current ? [current].concat(items) : items;
        if(all.length < 2) return;
        buildCards(section, all);
        section.hidden = false;
      })
      .catch(function(){ /* leave hidden */ });
  });
})();
